import React from 'react';
import classNames from 'classnames';
import InfoCard from './InfoCard';
import styles from '../TripTrackingV2.module.scss';

const CONSENT_CLASS = {
  allowed: styles.allowed,
  pending: styles.pending,
  not_added: styles.notAdded,
};

const ContactCard = ({ title, icon, name, lines = [], consentStatus }) => (
  <InfoCard title={title}>
    <div className={styles.contactRow}>
      <div className={styles.contactIcon}>
        <img src={icon} width="18" height="18" />
      </div>
      <div>
        <div className={styles.contactName}>
          {name || '-'}
          {consentStatus && <span className={classNames(styles.consentDot, CONSENT_CLASS[consentStatus])} />}
        </div>
        {lines.filter(Boolean).map((line) => (
          <div className={styles.contactLine} key={line}>{line}</div>
        ))}
      </div>
    </div>
  </InfoCard>
);

export default ContactCard;
